import React, { useState } from 'react'
import styles from './SkuLine.module.scss'
import { Input, LabeledDropdown, IconButton, Button, SkuAttribute } from 'components'
import { icons } from 'assets'
import { Props } from './types'
import { PRODUCT_STORE } from 'store'
import { ObjectsPopupSelector, LightTableLineContainer } from 'components/common'
import { inject } from 'mobx-react'
import { Image, Attribute } from 'models'

const SkuLine = (props: Props) => {
  const {
    sku,
    setSkuProp,
    additionalProps,
    [PRODUCT_STORE]: { productToView: { images } }
  } = props

  const [showPopup, setShowPopup] = useState(false)

  const setSelectedImageList = (list: Image[]) => {
    const { skus, setSkus } = additionalProps
    const cloneSkus = [...skus]
    const skuIndex = cloneSkus.findIndex(s => s.id === sku.id)
    cloneSkus[skuIndex] = { ...cloneSkus[skuIndex], images: list }
    setSkus(cloneSkus)
  }

  const renderAttributes = () => {
    return (
      <div className={styles.optionsContainer}>
        {sku.attributes && sku.attributes.map((attr: Attribute) =>
          <SkuAttribute key={attr.value} attribute={attr} />
        )}
      </div>
    )
  }

  return (
    <LightTableLineContainer>

      <Input
        className={styles.skuInput}
        placeholder='SKU number'
        value={sku.sku}
        onChange={skuNum => setSkuProp({ sku: skuNum })}
      />

      {renderAttributes()}

      <Input
        className={styles.stockInput}
        placeholder='Stock'
        type='number'
        min={0}
        value={sku.stock}
        onChange={stock => setSkuProp({ stock: Number(stock) })}
      />

      <Input
        className={styles.priceInput}
        placeholder='Price'
        type='number'
        min={0}
        value={sku.price}
        onChange={price => setSkuProp({ price: Number(price) })}
      />
      <LabeledDropdown
        size='small'
        options={['USD', 'ILS', 'EUR', 'GBP']}
        placeholder='Currency'
        className={styles.currencyDropdown}
        selectedOptions={[sku.curr]}
        onSelect={([curr]) => setSkuProp({ curr })}
      />

      <IconButton
        icon={icons.imageGallery}
        className={styles.imagesBttn}
        onClick={() => setShowPopup(true)}
      />
      <span className={styles.imagesCounter}>({sku.images ? sku.images.length : 0})</span>

      <Button
        size='small'
        type='cancel'
      >
        delete
      </Button>

      {showPopup &&
        <ObjectsPopupSelector
          title={`Manage images for SKU: ${sku.sku}`}
          topComponent={renderAttributes()}
          onClose={() => setShowPopup(false)}
          objectsList={images}
          selectedObjectsList={sku.images}
          setSelectedList={setSelectedImageList}
        />
      }

    </LightTableLineContainer>
  )
}

export default inject(PRODUCT_STORE)(SkuLine)
